import React, { useState, useEffect } from 'react';
import axios from 'axios';
import API_ENDPOINTS from '../config/api.js';
import logger from '../utils/logger.js';

const ApiTest = () => {
  const [testResults, setTestResults] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const runTests = async () => {
    setLoading(true);
    setError(null);
    const results = {};

    logger.info('Démarrage des tests API');

    try {
      // Test 1: Endpoint de santé
      logger.debug('Test 1: Endpoint de santé...');
      const healthResponse = await axios.get(`${API_ENDPOINTS.BASE}/health`);
      results.health = {
        success: true,
        data: healthResponse.data,
        message: 'Endpoint de santé accessible'
      };

      // Test 2: API Transporteurs
      console.log('Test 2: API Transporteurs...');
      const transporteursResponse = await axios.get(API_ENDPOINTS.TRANSPORTEURS);
      results.transporteurs = {
        success: transporteursResponse.data.success,
        data: transporteursResponse.data.data,
        message: 'API Transporteurs accessible'
      };

      // Test 3: API Clients
      console.log('Test 3: API Clients...');
      const clientsResponse = await axios.get(API_ENDPOINTS.CLIENTS);
      results.clients = {
        success: clientsResponse.data.success,
        data: clientsResponse.data.data,
        message: 'API Clients accessible'
      };

      // Test 4: API Commissionnaires
      console.log('Test 4: API Commissionnaires...');
      const commissionnairesResponse = await axios.get(API_ENDPOINTS.COMMISSIONNAIRES);
      results.commissionnaires = {
        success: commissionnairesResponse.data.success,
        data: commissionnairesResponse.data.data,
        message: 'API Commissionnaires accessible'
      };

      // Test 5: API Devis
      console.log('Test 5: API Devis...');
      const devisResponse = await axios.get(API_ENDPOINTS.ESTIMATES);
      results.devis = {
        success: devisResponse.data.success,
        data: devisResponse.data.data,
        message: 'API Devis accessible'
      };

      // Test 6: API Factures
      console.log('Test 6: API Factures...');
      const facturesResponse = await axios.get(API_ENDPOINTS.INVOICES);
      results.factures = {
        success: facturesResponse.data.success,
        data: facturesResponse.data.data,
        message: 'API Factures accessible'
      };

    } catch (err) {
      logger.error('Erreur lors des tests API', {
        error: err.message,
        stack: err.stack
      });
      setError(err.message);
    }

    setTestResults(results);
    setLoading(false);
  };

  useEffect(() => {
    runTests();
  }, []);

  const getStatusIcon = (success) => {
    return success ? '✅' : '❌';
  };

  const getStatusColor = (success) => {
    return success ? 'text-green-600' : 'text-red-600';
  };

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white rounded-lg shadow-lg">
      <h2 className="text-2xl font-bold mb-6 text-gray-800">Test de Connexion API</h2>
      
      <div className="mb-4">
        <button
          onClick={runTests}
          disabled={loading}
          className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded disabled:opacity-50"
        >
          {loading ? 'Tests en cours...' : 'Relancer les tests'}
        </button>
      </div>

      {error && (
        <div className="mb-4 p-4 bg-red-100 border border-red-400 text-red-700 rounded">
          <strong>Erreur:</strong> {error}
        </div>
      )}

      <div className="grid gap-4">
        {Object.entries(testResults).map(([key, result]) => (
          <div key={key} className="border rounded-lg p-4">
            <div className="flex items-center justify-between mb-2">
              <h3 className="text-lg font-semibold capitalize">{key}</h3>
              <span className={`text-lg ${getStatusColor(result.success)}`}>
                {getStatusIcon(result.success)}
              </span>
            </div>
            <p className="text-gray-600 mb-2">{result.message}</p>
            {result.data && (
              <div className="text-sm text-gray-500">
                <strong>Données:</strong> {Array.isArray(result.data) ? result.data.length : 'N/A'} éléments
              </div>
            )}
            {result.data && typeof result.data === 'object' && !Array.isArray(result.data) && (
              <div className="text-sm text-gray-500">
                <strong>Statut:</strong> {result.data.status || 'N/A'}
              </div>
            )}
          </div>
        ))}
      </div>

      {Object.keys(testResults).length > 0 && (
        <div className="mt-6 p-4 bg-gray-50 rounded-lg">
          <h4 className="font-semibold mb-2">Résumé de la configuration:</h4>
          <div className="text-sm text-gray-600">
            <p><strong>URL API de base:</strong> {API_ENDPOINTS.BASE}</p>
            <p><strong>Mode:</strong> {import.meta.env.VITE_NODE_ENV || 'development'}</p>
            <p><strong>Tests réussis:</strong> {Object.values(testResults).filter(r => r.success).length}/{Object.keys(testResults).length}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ApiTest;
